import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Photo<span>Grid</span></h1>
      <h2>Your Pictures</h2>
      <p>Upload / Save  images here!</p>
    </div>
  )
}

export default Title;